<template>
  <div class="bitcoin-detail-blocks">
    <div class="bitcoin-detail-blocks_title">
      <BaseSkeleton class="w-[120px] h-[20px] rounded-md" />
    </div>
    <div class="bitcoin-detail-blocks_content">
      <div class="bitcoin-detail-blocks_header">
        <div
          v-for="index in 2"
          :key="`input-${index}`"
          class="address-block-skeleton"
        >
          <BaseSkeleton class="w-[80px] h-[14px] rounded-md mb-[8px]" />
          <div class="address-block_address_row">
            <BaseSkeleton class="w-[200px] h-[16px] rounded-md" />
          </div>
          <BaseSkeleton
            class="w-[60px] h-[14px] rounded-md mt-[8px] mb-[4px]"
          />
          <div class="address-block_amount_row">
            <BaseSkeleton class="w-[120px] h-[16px] rounded-md" />
          </div>
        </div>
      </div>
      <div class="bitcoin-detail-blocks_column">
        <div
          v-for="index in 3"
          :key="`output-${index}`"
          class="address-block-skeleton"
        >
          <BaseSkeleton class="w-[80px] h-[14px] rounded-md mb-[8px]" />
          <div class="address-block_address_row">
            <BaseSkeleton class="w-[200px] h-[16px] rounded-md" />
          </div>
          <BaseSkeleton
            class="w-[60px] h-[14px] rounded-md mt-[8px] mb-[4px]"
          />
          <div class="address-block_amount_row">
            <BaseSkeleton class="w-[120px] h-[16px] rounded-md" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseSkeleton from "@/shared/ui/BaseSkeleton/BaseSkeleton.vue";
</script>

<style lang="scss" scoped>
/* Renamed main class and restored original styles */
.bitcoin-detail-blocks {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 32px;

  &_title {
    padding-bottom: 10px;
    margin-bottom: 16px;
    border-bottom: 1px solid var(--Dark-850, #1a1a1a);

    &-text {
      font-size: 16px !important;
      color: #fafafa !important;
      line-height: 150% !important;
    }
  }

  &_content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    border-bottom: 1px solid var(--Dark-850, #1a1a1a);
    padding-bottom: 24px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &_column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &_header {
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 768px) {
      gap: 10px;
    }
  }

  .show-more {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 7px;
    padding-top: 24px;
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: inherit; // Ensure text size matches surrounding text
  }

  .arrow {
    transition: transform 0.3s ease;
    transform: rotate(90deg);
    width: 16px;
    height: 16px;

    &.rotate-up {
      transform: rotate(-90deg);
    }
  }

  .coinbase-card {
    display: flex;
    align-items: center;
    gap: 13px;
    border-radius: 10px;
    border: 1px solid var(--Dark-850, #1a1a1a);
    padding: 27px 24px; // Размерность как у блоков output
  }
}
</style>
